import { render, staticRenderFns } from "./M22.vue?vue&type=template&id=9a698c70&scoped=true"
import script from "./M22.vue?vue&type=script&lang=js"
export * from "./M22.vue?vue&type=script&lang=js"
import style0 from "./M22.vue?vue&type=style&index=0&id=9a698c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a698c70",
  null
  
)

export default component.exports